module.exports = __webpack_public_path__ + "static/img/sideBar.ddaf09a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/sideBar.png
// module id = NxDv
// module chunks = 1